export default __webpack_public_path__ + "static/media/back-arrow-black.d0dfec9a.svg";